<template>
  <div>
    <vs-chip v-for="(t, i) in display" :key="i">
      <i>{{ t.value }}</i>
    </vs-chip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      display: [],
    };
  },
  created() {
    if (this.params.value) {
      this.display = JSON.parse(this.params.value);
    } else this.display.push({ value: "Etiketsiz" });
  },
};
</script>

